import React from 'react';
import axios from "../../../../containers/api";
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalHeader} from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";
import NewUserModal from "../../../../components/admin/NewUserModal";

class AddMainBranch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isModal: this.props && this.props.isModal,
            showNewMemberModal: false,
            agentMainName: "",
            agentMainManagerName: "",
            agentMainAddress: "",
            agentMainTel: "",
            agentMainFax: "",
            agentMainEconomic: "",
            agentMainNationID: "",
            agentMainWebAddress: "",
            agentMainEmailAddress: ""
        }
    }

    componentDidMount() {
        if (!this.state.isModal) {
            this.CheckMemberTypeIsAdmin();
        }
    }

    CheckMemberTypeIsAdmin = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/CheckMemberTypeIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    AddAgentMain = () => {
        if (this.state.agentMainName.length < 6) {
            this.props.showAlert("نام دفتر مرکزی نمی‌تواند کمتر از ۶ حرف باشد.", "error")
        } else if (this.state.agentMainNationID.length < 10 || this.state.agentMainNationID.length > 11) {
            this.props.showAlert("کد ملی نباید کمتر از ۱۰ حرف و بیشتر از ۱۱ حرف باشد.", "error");
        } else {
            const addModel = {
                AgentMainName: toEnglishNumbers(this.state.agentMainName),
                AgentMainManagerName: toEnglishNumbers(this.state.agentMainManagerName),
                AgentMainAddress: toEnglishNumbers(this.state.agentMainAddress),
                AgentMainTel: toEnglishNumbers(this.state.agentMainTel),
                AgentMainFax: toEnglishNumbers(this.state.agentMainFax),
                AgentMainEconomic: toEnglishNumbers(this.state.agentMainEconomic),
                AgentMainNationID: toEnglishNumbers(this.state.agentMainNationID),
                AgentMainWebAddress: toEnglishNumbers(this.state.agentMainWebAddress),
                AgentMainEmailAddress: toEnglishNumbers(this.state.agentMainEmailAddress)
            };

            this.props.showSpinner();
            axios.post('api/AgencyApi/AddMainBranchAgency', addModel)
                .then((res) => {
                    this.props.hideSpinner();
                    this.props.showAlert("دفتر مرکزی با موفقیت ثبت شد", "success");
                    this.setState({
                        newMemberUsername: res.data.username,
                        newMemberPassword: res.data.password,
                        showNewMemberModal: true
                    });
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    this.props.showAlert(showCatchError(error), "error");
                    console.log(error.response);
                });
        }
    };

    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام</Label>
                        <Input value={this.state.agentMainName} maxLength={150}
                               onChange={(e) => this.setState({ agentMainName: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام کامل مدیر مرکز</Label>
                        <Input value={this.state.agentMainManagerName} maxLength={100}
                               onChange={(e) => this.setState({ agentMainManagerName: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد ملی</Label>
                        <Input value={this.state.agentMainNationID} maxLength={50}
                               onChange={(e) => this.setState({ agentMainNationID: e.target.value.replace(/[^0-9۰-۹]/g, "") })}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد اقتصادی</Label>
                        <Input value={this.state.agentMainEconomic} maxLength={50}
                               onChange={(e) => this.setState({ agentMainEconomic: e.target.value.replace(/[^0-9۰-۹]/g, "") })}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>فکس</Label>
                        <Input value={this.state.agentMainFax} maxLength={50}
                               onChange={(e) => this.setState({ agentMainFax: e.target.value.replace(/[^0-9۰-۹]/g, "") })}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>تلفن</Label>
                        <Input value={this.state.agentMainTel} maxLength={50}
                               onChange={(e) => this.setState({ agentMainTel: e.target.value.replace(/[^0-9۰-۹]/g, "") })}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>ایمیل</Label>
                        <Input value={this.state.agentMainEmailAddress} maxLength={50}
                               onChange={(e) => this.setState({ agentMainEmailAddress: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>وبسایت</Label>
                        <Input value={this.state.agentMainWebAddress} maxLength={50}
                               onChange={(e) => this.setState({ agentMainWebAddress: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-50 w-100 px-1">
                        <Label>آدرس</Label>
                        <Input value={this.state.agentMainAddress} maxLength={550}
                               onChange={(e) => this.setState({ agentMainAddress: e.target.value })}/>
                    </FormGroup>
                </div>

                <div className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.AddAgentMain()}>
                            ذخیره
                        </Button>
                    </FormGroup>
                </div>

                <Modal isOpen={this.state.showNewMemberModal} toggle={() => this.setState({showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null})}>
                    <ModalHeader toggle={() => this.setState({showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null})}>
                        اطلاعات کاربری
                    </ModalHeader>
                    <ModalBody>
                        <NewUserModal
                            newMemberUsername={this.state.newMemberUsername}
                            newMemberPassword={this.state.newMemberPassword}
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default AddMainBranch;